export default __webpack_public_path__ + "static/media/sha.869c42da.png";